import useSWRImmutable from "swr/immutable";
import useAuthenticatedAxios from "./use-authenticated-axios";

export default function useClauses() {
  const axios = useAuthenticatedAxios();
  const {
    data: clauses,
    error,
    isLoading,
  } = useSWRImmutable("clauses", (url) => {
    return axios.get(url).then((res) => res.data);
  });

  return {
    clauses: clauses || [],
    error,
    isLoading,
  };
}
